import type { TranslationInterface } from './translation.types';

export const ptLocale: TranslationInterface = {
  'write-a-message': 'Escreva uma mensagem...',
  'session-closed-lead': 'Seu problema foi resolvido!',
  'new-conversation': 'Nova conversa',
  'welcome-title': 'Bem-vindo ao nosso chat de suporte',
  'welcome-description':
    'Estamos aqui para ajudar! Inicie uma conversa e responderemos o mais rápido possível.',
  'your-name': 'Seu nome',
  'your-email': 'Seu endereço de email',
  'start-chat': 'Falar com o suporte',
  'starting-chat': 'Conectando...',
  'i-need-more-help': 'preciso de mais ajuda',
  'this-was-helpful': 'Isso foi útil',
  optional: 'Opcional',
  'no-conversations-yet': 'Nenhuma conversa ainda',
  'back-to-conversations': 'Voltar para conversas',
  'closed-conversations': 'Conversas fechadas',
};
